import PropTypes from "prop-types";
import React, { Component } from "react";
import AlertDialog from "../AlertDialog";
import { connect } from "react-redux";
import { goToBeginning } from "../../utils/scenario-manager";

class NoAvailableAppointment extends Component {
  goToBeginning = () => {
    this.props.goToBeginning();
  };

  render() {
    const { step } = this.props;
    return (
      <AlertDialog
        content={step.message.message}
        onClick={this.goToBeginning}
        isResetAlert={true}
      />
    );
  }
}

NoAvailableAppointment.propTypes = {
  goToBeginning: PropTypes.func,
  step: PropTypes.shape({
    message: PropTypes.shape({
      message: PropTypes.any
    })
  })
};

const mapDispatchToProps = dispatch => ({
  goToBeginning: () => dispatch(goToBeginning())
});

export default connect(
  null,
  mapDispatchToProps
)(NoAvailableAppointment);
